import React from 'react';
import { Translate } from 'core/translate';
import { Carrot } from '../../common/notifications/NotificationsTrigger';
import { NetLine } from './Lines';
import { PriceWithConditionalNotification } from './Price';
import Currency from '../../common/intl/Currency';
import MathBoxGroup from './MathBoxGroup';

const EmployeeNetPriceGroup = ({ pricing, isSummary }) => {
  const { netEmployeePrice, isSeeDealer } = pricing;

  return (
    <MathBoxGroup>
      <NetLine
        labelKey="net.employee.price"
        price={
          <PriceWithConditionalNotification
            notificationName="employee-net-price"
            symbol={Carrot}
            inlineNotification={!isSummary}>
            {isSeeDealer ? (
              <Translate value="unknown.price.text" />
            ) : (
              <Currency value={netEmployeePrice} />
            )}
          </PriceWithConditionalNotification>
        }
      />
    </MathBoxGroup>
  );
};

const USEmployeeNetPriceGroup = ({ pricing, isSummary }) => {
  const { netEmployeePrice, isSeeDealer } = pricing;
  let label;
  if (pricing.employeePrice) {
    label = 'net.employee.price';
  }
  if (!pricing.employeePrice) {
    if (pricing.incentives.total || pricing.incentives.value) {
      label = 'net.price.after.offers';
    } else label = 'total.vehicle.price';
  }

  return (
    <MathBoxGroup>
      <NetLine
        labelKey={label}
        price={
          <PriceWithConditionalNotification
            notificationName="msrp"
            inlineNotification={!isSummary}>
            {isSeeDealer ? (
              <Translate value="unknown.price.text" />
            ) : (
              <Currency value={netEmployeePrice} />
            )}
          </PriceWithConditionalNotification>
        }
      />
    </MathBoxGroup>
  );
};

const DefaultNetPriceGroup = ({ pricing, eventName, isSummary }) => {
  const { isConfidencePrice, netPrice, isSeeDealer } = pricing;

  return (
    <MathBoxGroup>
      <NetLine
        label={
          <Translate
            value={isConfidencePrice ? 'event.net.price' : 'net.price'}
            eventName={eventName}
          />
        }
        price={
          <PriceWithConditionalNotification
            notificationName="msrp"
            inlineNotification={!isSummary}>
            {isSeeDealer ? (
              <Translate value="unknown.price.text" />
            ) : (
              <Currency value={netPrice} />
            )}
          </PriceWithConditionalNotification>
        }
      />
    </MathBoxGroup>
  );
};

const NetPriceGroup = ({
  pricing,
  eventName,
  isSummary,
  isCanada,
  isFamilyFirstUS
}) => {
  if (isCanada && pricing.employeePrice) {
    return <EmployeeNetPriceGroup pricing={pricing} isSummary={isSummary} />;
  }

  if (isFamilyFirstUS) {
    return <USEmployeeNetPriceGroup pricing={pricing} isSummary={isSummary} />;
  }

  return (
    <DefaultNetPriceGroup
      isFamilyFirstUS={isFamilyFirstUS}
      pricing={pricing}
      eventName={eventName}
      isSummary={isSummary}
    />
  );
};

export default NetPriceGroup;
